import { render, staticRenderFns } from "./ownerContract-add-or-update.vue?vue&type=template&id=3d04abb9&scoped=true"
import script from "./ownerContract-add-or-update.vue?vue&type=script&lang=js"
export * from "./ownerContract-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./ownerContract-add-or-update.vue?vue&type=style&index=0&id=3d04abb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d04abb9",
  null
  
)

export default component.exports